import { useTranslation } from 'react-i18next';
import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';

import { PlasseringAvEnhetIByggVertikalt } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

export const VertikalPlasseringRadio = () => {
  const { t } = useTranslation();
  const { register, formState } = useOmBoligenFormContext();

  const error = formState.errors.bygginfo?.verticalPlacement?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>
        {t('register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.label')}
      </Fieldset.Legend>
      <Radio
        {...register('bygginfo.verticalPlacement', {
          required: t('register.errorMessage.field.vertikalPlassering'),
          shouldUnregister: true
        })}
        label={t(
          `register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.option.${PlasseringAvEnhetIByggVertikalt.OversteEtasje}`
        )}
        value={PlasseringAvEnhetIByggVertikalt.OversteEtasje}
        aria-invalid={!!error}
      />
      <Radio
        {...register('bygginfo.verticalPlacement', {
          required: t('register.errorMessage.field.vertikalPlassering'),
          shouldUnregister: true
        })}
        label={t(
          `register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.option.${PlasseringAvEnhetIByggVertikalt.NedersteEtasje}`
        )}
        value={PlasseringAvEnhetIByggVertikalt.NedersteEtasje}
        aria-invalid={!!error}
      />
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Fieldset>
  );
};
